<script lang="ts">
    import {getCurrentLanguage} from 'src/core';
    import type {Price} from 'src/typings';
    import {pipe} from 'core/utils';
    import {priceFormatter} from '../../utils/pipes';

    const currentLanguage = getCurrentLanguage();

    export let price: Price;
</script>

{#if price}
    <span class="price-text" class:zero-value={price.amount === 0}>{pipe(price, priceFormatter(currentLanguage))}</span>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .price-text.zero-value {
        color: @themed-text-muted;
    }
</style>